
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"21","viewBox":"0 0 20 21","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.635 17.962a.834.834 0 01-.386-.094l-4.25-2.22-4.248 2.22a.835.835 0 01-1.206-.88l.809-4.69L1.92 8.976a.835.835 0 01.46-1.424l4.75-.69 2.124-4.271c.281-.567 1.21-.567 1.492 0l2.124 4.271 4.75.69a.831.831 0 01.46 1.424l-3.434 3.32.81 4.69a.833.833 0 01-.821.976z"}})])
          )
        }
      }
    